import toast from 'react-hot-toast'

import { CustomToast } from 'components/uikit/CustomToast'

export const useToast = () => {
  const showToast = (config: { message: string; type: 'success' | 'error' }) => {
    const duration = 5000

    toast(t => <CustomToast message={config.message} type={config.type} id={t.id} />, {
      position: 'top-right',
      duration: duration,
    })
  }

  return {
    showToast,
    dismiss: toast.dismiss,
  }
}
